import { render, staticRenderFns } from "./ProofreadingPreviewPlanPage.vue?vue&type=template&id=6a5d7191"
import script from "./ProofreadingPreviewPlanPage.vue?vue&type=script&lang=ts"
export * from "./ProofreadingPreviewPlanPage.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/nola-frontend/nola-frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6a5d7191')) {
      api.createRecord('6a5d7191', component.options)
    } else {
      api.reload('6a5d7191', component.options)
    }
    module.hot.accept("./ProofreadingPreviewPlanPage.vue?vue&type=template&id=6a5d7191", function () {
      api.rerender('6a5d7191', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/novel/ProofreadingPreviewPlanPage.vue"
export default component.exports